import React from 'react';
import { Calendar, Clock, MapPin, Users, FileText } from 'lucide-react';

const DetailItem = ({ icon: Icon, label, children, className = '' }) => (
  <div className={`flex items-start gap-3 ${className}`}>
    <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-50 border border-gray-100 text-gray-700">
      <Icon className="w-4 h-4" />
    </div>
    <div className="min-w-0">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-0.5">
        {label}
      </p>
      <div className="text-sm font-medium text-gray-900 leading-snug">{children}</div>
    </div>
  </div>
);

const EventDetails = ({ booking, formatDate, formatTime }) => {
  return (
    <section className="rounded-2xl border border-gray-200 bg-white p-5 sm:p-6 shadow-sm">
      <div className="mb-5">
        <h2 className="text-base font-bold text-gray-900">Event details</h2>
        <p className="text-sm text-gray-500 mt-0.5">When and where this job happens</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <DetailItem icon={Calendar} label="Event date">
          {formatDate(booking.event_date)}
        </DetailItem>
        <DetailItem icon={Clock} label="Time">
          {formatTime(booking.start_time)} – {formatTime(booking.end_time)}
        </DetailItem>
        <DetailItem icon={Clock} label="Duration">
          {booking.duration_hours} hours
        </DetailItem>
        {booking.guest_count ? (
          <DetailItem icon={Users} label="Guest count">
            {booking.guest_count} guests
          </DetailItem>
        ) : null}
        {booking.event_location ? (
          <DetailItem icon={MapPin} label="Location" className="sm:col-span-2">
            <p className="break-words">{booking.event_location}</p>
            {booking.event_address && booking.event_address !== booking.event_location ? (
              <p className="text-xs text-gray-500 mt-1 break-words font-normal">
                {booking.event_address}
              </p>
            ) : null}
          </DetailItem>
        ) : null}
        {booking.event_type ? (
          <DetailItem icon={FileText} label="Event type" className="sm:col-span-2">
            {booking.event_type}
          </DetailItem>
        ) : null}
      </div>

      {(booking.special_requirements || booking.special_requests) && (
        <div className="mt-5 pt-5 border-t border-gray-100 space-y-4">
          {booking.special_requirements ? (
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-1">
                Special requirements
              </p>
              <p className="text-sm text-gray-800 leading-relaxed">{booking.special_requirements}</p>
            </div>
          ) : null}
          {booking.special_requests ? (
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-1">
                Special requests
              </p>
              <p className="text-sm text-gray-800 leading-relaxed">{booking.special_requests}</p>
            </div>
          ) : null}
        </div>
      )}
    </section>
  );
};

export default EventDetails;
